<template>
	<div class="page">
		<MainHeader v-bind:page="'Talentenspel Begeleiding'"></MainHeader>
		<div class="container">
			<div class="row">
				<div class="whole component">
					<img :src="headerImage" width="938px" />
					<h1>Talentenspel Begeleiding</h1>
					<p class="highlight">In mijn praktijk wordt er ingegaan op levensvragen die wij allemaal hebben. We worden geraakt door situaties in ons leven die we willen onderzoeken. Vragen die vaak gaan over een diepere betekenis van het leven zelf. Wie ben ik, waarom ben ik hier, wat kom ik hier doen? Waarom ben ik in dit gezin geboren, hoe ga ik om met scheiding, verlies, afscheid en/of wie staat mij bij als ik het even niet meer ziet zitten?</p>
					
					<p class="highlight">Mijn werk als coach / counselor gaat over het meelopen op iemands levenspad. Naast iemand staan of lopen betekent voor mij het innerlijk proces bij de ander zijn werk laten doen. Het betekent letterlijk laten ontvouwen wat er zichtbaar mag worden.  Hierin komt mijn missie het meest tot zijn recht.</p>

					<p class="highlight" style="text-align: center;"><i>~ De schat die iemand in zijn diepste kern is, helpen zichtbaar, hoorbaar en ervaarbaar te maken. ~</i></p>
                </div>
            </div>
			<div class="row">
				<div class="half component">
					<h2>De begeleiding</h2>
					<p>In de begeleiding wordt gebruik gemaakt van het Talentenspel of het Jong Talent als basis. Er zijn verschillende borden van het Talentenspel waarmee gewerkt wordt.</p>

					<p>Tijdens de begeleiding met het Talentenspel kunnen aanvullende oefeningen worden gebruikt. Dit kunnen bijvoorbeeld meditatie oefeningen, Mindfulness en / of creatieve opdrachten zijn.</p>
				</div>
				<div class="half component">
					<h2>Individuele begeleiding: waar en hoe vaak is een gesprek nodig?</h2>
					<p>Een individuele begeleiding met het Talentenspel vraagt 3 tot 5 sessies van elk 2 ½ uur. Hierin werken we alleen met de basisborden van het Talentenspel of Jong Talent. Een tijdsinvestering van zo’n 10 uur gemiddeld.</p>
					<p>Samen bepalen we de periode waarin de begeleiding plaatsvindt. Tussen twee afspraken zit minimaal twee weken. Dit geeft de ruimte om hetgeen wat bewust gemaakt is met het spel ook te kunnen integreren. Er kunnen opdrachten worden meegegeven voor de tussenliggende periode.</p>
					<p>Na het basistraject bestaat de mogelijkheid begeleid te worden met de verdiepingsborden.</p>
				</div>
			</div>
			<div class="row">
				<div class="whole component">
					<h2>Voor wie?</h2>
				</div>
			</div>
			<div class="row">
				<div class="whole component" style="padding: 0 200px;">
					<p>Begeleiding is geschikt voor als je bijvoorbeeld met de volgende vragen rondloopt;<br>
					<ul>
						<li>Je loopt rond met levensvragen en zoekt naar antwoorden.</li>
						<li>Je staat op de drempel maar durft er niet overheen.</li>
						<li>Je ervaart angsten voor datgene wat innerlijk gevraagd wordt om een stap te nemen.</li>
						<li>Je bent op zoek naar bezieling en bewustwording.</li>
						<li>Je bent op zoek naar de opleiding of beroep die het meest bij jou past.</li>
						<li>Je wilt jouw innerlijke schat zichtbaar maken, maar wie ben jij echt?</li>
						<li>Je hebt een burn-out (gehad) en je mag nieuwe keuzes maken, durf je dat?</li>
						<li>Loop je vast in je huidige baan en wil je helderheid hebben over jouw talenten, jouw leiderschap en jouw missie?</li>
						<li>Je wilt een bedrijf starten en je bent op zoek naar jouw missie voor dit bedrijf.</li>
					</ul></p>
				</div>
				<!-- <div class="half component">
					<img :src="talentenspelBegeleiding1" width="449px" />
				</div> -->
			</div>
			
			<div class="row">
				<div class="whole component">
					<p>Ik ben opgeleid tot gecertificeerd coach en trainer met alle borden van het Talentenspel. Voor meer informatie over het Talentenspel kunt u terecht bij <a href='https://www.talentenspel.nl/'>www.talentenspel.nl</a></p>

					<p>Wilt u informatie over bovenstaande begeleidingstrajecten neem dan <router-link to="/contact">contact</router-link> met mij op. </p>
				</div>
			</div>
		</div>
		<MainFooter style="display:flex; margin-left: auto; margin-right:auto;"></MainFooter>
	</div>
</template>

<script>
import MainHeader from '../MainHeader';
import MainFooter from '../MainFooter';

export default {
	name: 'Coaching-Counseling',
	data() {
		return {
			headerImage: require('../../img/talentenspel_begeleiding_header.jpeg'),
			talentenspelBegeleiding1: require('../../img/talentenspel_begeleiding_1.jpg'),
			talentenspelBegeleiding2: require('../../img/talentenspel_begeleiding_2.jpg')
		}
	},
	computed: {
	},
	methods: {
	},
	components: {
		MainHeader, MainFooter
	}
}
</script>



// WEBPACK FOOTER //
// src/components/pages/TalentenspelBegeleiding.vue